"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _updateCart = _interopRequireDefault(require("./utils/update-cart"));
var _getOptions = _interopRequireDefault(require("../fetch/get-options"));
var _trackEvent = _interopRequireDefault(require("../../../../../analytics/track-event"));
var _getWebshellclientLocale = _interopRequireDefault(require("../../../../../utils/get-webshellclient-locale"));
var _getQueryKey = _interopRequireDefault(require("../../../../product-feed-threads/v2/get-query-key"));
var _getQueryKey2 = _interopRequireDefault(require("../get-query-key"));
var _getQueryKey3 = _interopRequireDefault(require("../../../cart_reviews/v2/get-query-key"));
var _getQueryKey4 = _interopRequireDefault(require("../../../partner_cart_reviews/v1/get-query-key"));
var _getQueryKey5 = _interopRequireDefault(require("../../../partner_cart_reviews/v2/get-query-key"));
var _handleErrors = _interopRequireDefault(require("../utils/handle-errors"));
var _handleWarnings = _interopRequireDefault(require("../utils/handle-warnings"));
var _excluded = ["designViewId", "designViewIds", "giftCard", "isDigitalGiftCard", "isPhysicalGiftCard", "offer", "offers", "quantity", "recipient", "recipientEmailAddress", "shippingMethod", "skuId", "valueAddedServices"];
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
var getCountry = function getCountry() {
  var _getWebShellClientLoc;
  return (_getWebShellClientLoc = (0, _getWebshellclientLocale["default"])().country) === null || _getWebShellClientLoc === void 0 ? void 0 : _getWebShellClientLoc.toUpperCase();
};
var addToCart = /*#__PURE__*/function () {
  var _ref2 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(_ref) {
    var items, itemId, designViewIds, amount, postalAddress1, postalAddress2, postalCity, postalCountry, postalState, postalZipCode, _ref$quantity, quantity, recipientEmailAddress, recipientFirstName, recipientLastName, shippingMethod, params, country, item;
    return _regenerator().w(function (_context) {
      while (1) switch (_context.n) {
        case 0:
          items = _ref.items, itemId = _ref.itemId, designViewIds = _ref.designViewIds, amount = _ref.amount, postalAddress1 = _ref.postalAddress1, postalAddress2 = _ref.postalAddress2, postalCity = _ref.postalCity, postalCountry = _ref.postalCountry, postalState = _ref.postalState, postalZipCode = _ref.postalZipCode, _ref$quantity = _ref.quantity, quantity = _ref$quantity === void 0 ? 1 : _ref$quantity, recipientEmailAddress = _ref.recipientEmailAddress, recipientFirstName = _ref.recipientFirstName, recipientLastName = _ref.recipientLastName, shippingMethod = _ref.shippingMethod;
          params = {
            designViewIds: designViewIds,
            items: items,
            id: itemId
          };
          country = getCountry(); // Gift Card specific props
          if (amount) {
            item = _objectSpread(_objectSpread({}, params === null || params === void 0 ? void 0 : params.items[0]), {}, {
              giftCard: {
                amount: amount
              },
              shippingMethod: shippingMethod,
              shippingAddress: {
                country: country
              },
              recipient: {
                firstName: recipientFirstName,
                lastName: recipientLastName
              }
            }); // Digital gift cards
            if (recipientEmailAddress) {
              item.shippingAddress.email = recipientEmailAddress;
              item.quantity = 1;
            } else {
              // Physical gift cards
              item.shippingAddress = _objectSpread(_objectSpread({}, item.shippingAddress), {}, {
                address1: postalAddress1,
                address2: postalAddress2,
                city: postalCity,
                state: postalState,
                postalCode: postalZipCode,
                country: postalCountry || country
              });
              item.quantity = parseInt(quantity, 10) || 1;
            }
          }
          return _context.a(2, (0, _updateCart["default"])(params));
      }
    }, _callee);
  }));
  return function addToCart(_x) {
    return _ref2.apply(this, arguments);
  };
}();
var getAddItemOptions = function getAddItemOptions(_ref3) {
  var queryClient = _ref3.queryClient;
  return {
    mutationFn: function () {
      var _mutationFn = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3(itemData) {
        var designViewId, designViewIds, giftCard, isDigitalGiftCard, isPhysicalGiftCard, offer, offers, quantity, recipient, recipientEmailAddress, shippingMethod, skuId, valueAddedServices, rest, cartPromise, country, isGiftCard, params, finalQuantity, trackProductAdded, cartId, response, _t;
        return _regenerator().w(function (_context3) {
          while (1) switch (_context3.n) {
            case 0:
              designViewId = itemData.designViewId, designViewIds = itemData.designViewIds, giftCard = itemData.giftCard, isDigitalGiftCard = itemData.isDigitalGiftCard, isPhysicalGiftCard = itemData.isPhysicalGiftCard, offer = itemData.offer, offers = itemData.offers, quantity = itemData.quantity, recipient = itemData.recipient, recipientEmailAddress = itemData.recipientEmailAddress, shippingMethod = itemData.shippingMethod, skuId = itemData.skuId, valueAddedServices = itemData.valueAddedServices, rest = _objectWithoutProperties(itemData, _excluded);
              cartPromise = queryClient.fetchQuery((0, _getOptions["default"])({
                queryClient: queryClient
              })); // NikeShop.addToCart()
              country = getCountry();
              isGiftCard = isDigitalGiftCard || isPhysicalGiftCard;
              params = _objectSpread(_objectSpread({}, rest), {}, {
                shippingMethod: shippingMethod
              });
              finalQuantity = quantity;
              if (!isDigitalGiftCard) {
                _context3.n = 1;
                break;
              }
              finalQuantity = 1;
              params.items = [{
                giftCard: giftCard,
                quantity: finalQuantity,
                recipient: recipient,
                shippingAddress: {
                  country: country,
                  email: recipientEmailAddress
                },
                shippingMethod: 'DIGITAL_GIFTCARD',
                skuId: skuId,
                valueAddedServices: valueAddedServices
              }];
              _context3.n = 5;
              break;
            case 1:
              if (!isPhysicalGiftCard) {
                _context3.n = 2;
                break;
              }
              finalQuantity = parseInt(quantity, 10) || 1;
              params.items = [{
                giftCard: giftCard,
                quantity: finalQuantity,
                shippingAddress: {
                  country: country
                },
                shippingMethod: shippingMethod,
                skuId: skuId,
                valueAddedServices: valueAddedServices
              }];
              _context3.n = 5;
              break;
            case 2:
              if (!designViewId) {
                _context3.n = 3;
                break;
              }
              finalQuantity = 1;
              // Passing a design view id a custom product
              params.designViewIds = [designViewId];
              params.offer = offer;
              params.offers = offers;
              _context3.n = 5;
              break;
            case 3:
              if (!skuId) {
                _context3.n = 4;
                break;
              }
              finalQuantity = quantity || 1;
              // Passing only a sku id implies a regular inline item,
              params.items = [{
                skuId: skuId,
                quantity: finalQuantity,
                offer: offer,
                offers: offers
              }];
              _context3.n = 5;
              break;
            case 4:
              (0, _trackEvent["default"])('nike-shop-product-added-error', null, {
                telemetryData: params,
                usePageAction: true
              });
              return _context3.a(2, Promise.reject(new Error('Missing required arguments of skuId for an inline product or skuId and designViewId for a custom product')));
            case 5:
              // since we are returning response we'll return response and track in between
              // NOTE: not awaited — fire-and-forget so it doesn't block the mutation return
              trackProductAdded = /*#__PURE__*/function () {
                var _ref4 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2(response) {
                  var _items$find;
                  var _ref5, cartId, currency, _ref5$items, items, addedItem, _ref6, productId, addedSkuId, productCode, gtin, priceInfo, _window$webShellClien, toUnitsNanos, getProtoEnums, CurrencyEnums, productFeedData, pid, category, brand, styleColor, content, productName;
                  return _regenerator().w(function (_context2) {
                    while (1) switch (_context2.n) {
                      case 0:
                        // Use response (not cached state) since state can have stale items from before the add
                        _ref5 = response !== null && response !== void 0 ? response : {}, cartId = _ref5.id, currency = _ref5.currency, _ref5$items = _ref5.items, items = _ref5$items === void 0 ? [] : _ref5$items;
                        addedItem = (_items$find = items.find(function (item) {
                          return item.skuId === skuId;
                        })) !== null && _items$find !== void 0 ? _items$find : items[0];
                        _ref6 = addedItem !== null && addedItem !== void 0 ? addedItem : {}, productId = _ref6.productId, addedSkuId = _ref6.skuId, productCode = _ref6.productCode, gtin = _ref6.gtin, priceInfo = _ref6.priceInfo;
                        if (!(cartId && productCode && gtin)) {
                          _context2.n = 2;
                          break;
                        }
                        _window$webShellClien = window.webShellClient.analytics.utils, toUnitsNanos = _window$webShellClien.toUnitsNanos, getProtoEnums = _window$webShellClien.getProtoEnums;
                        _context2.n = 1;
                        return getProtoEnums('Currency');
                      case 1:
                        CurrencyEnums = _context2.v;
                        window.webShellClient.analytics.trackAction({
                          underlyingAction: {
                            "case": 'coreCommerceV1CartModified',
                            value: {
                              cartId: cartId,
                              operation: {
                                "case": 'itemAdded',
                                value: {
                                  product: {
                                    "case": 'consumerProduct',
                                    value: {
                                      productCode: {
                                        value: productCode
                                      },
                                      gtin: {
                                        value: gtin
                                      }
                                    }
                                  },
                                  currency: CurrencyEnums[currency === null || currency === void 0 ? void 0 : currency.toUpperCase()],
                                  // Use per-unit prices, not aggregate line totals which scale with cart quantity
                                  fullPriceTotal: toUnitsNanos(priceInfo === null || priceInfo === void 0 ? void 0 : priceInfo.fullPrice),
                                  currentPriceTotal: toUnitsNanos(priceInfo === null || priceInfo === void 0 ? void 0 : priceInfo.price),
                                  quantity: finalQuantity
                                }
                              }
                            }
                          }
                        });
                      case 2:
                        productFeedData = queryClient.getQueryData((0, _getQueryKey["default"])({
                          productId: productId,
                          styleColor: productCode
                        })) || {};
                        pid = productFeedData.pid, category = productFeedData.productType, brand = productFeedData.brand, styleColor = productFeedData.styleColor, content = productFeedData.content;
                        productName = content === null || content === void 0 ? void 0 : content.title;
                        (0, _trackEvent["default"])('Product Added', {
                          brand: brand,
                          cartId: cartId,
                          category: category,
                          cloudProductId: productId,
                          currency: currency,
                          name: productName,
                          price: priceInfo === null || priceInfo === void 0 ? void 0 : priceInfo.price,
                          prodigyProductId: pid,
                          productId: pid,
                          quantity: finalQuantity,
                          sku: addedSkuId,
                          styleColor: styleColor
                        }, {
                          telemetryData: {
                            country: country,
                            designViewId: designViewId,
                            isGiftCard: isGiftCard,
                            items: params && params.items,
                            skuId: skuId
                          },
                          usePageAction: true
                        });
                        if (typeof window.pixlee_analytics !== 'undefined') {
                          window.pixlee_analytics.events.trigger('add:to:cart', {
                            product_sku: skuId,
                            price: priceInfo === null || priceInfo === void 0 ? void 0 : priceInfo.price,
                            quantity: quantity,
                            currency: currency
                          });
                        }
                      case 3:
                        return _context2.a(2);
                    }
                  }, _callee2);
                }));
                return function trackProductAdded(_x3) {
                  return _ref4.apply(this, arguments);
                };
              }();
              _context3.n = 6;
              return cartPromise;
            case 6:
              cartId = _context3.v.id;
              if (!(cartId && !isGiftCard)) {
                _context3.n = 8;
                break;
              }
              _context3.n = 7;
              return (0, _updateCart["default"])(params);
            case 7:
              _t = _context3.v;
              _context3.n = 10;
              break;
            case 8:
              _context3.n = 9;
              return addToCart(params);
            case 9:
              _t = _context3.v;
            case 10:
              response = _t;
              trackProductAdded(response);
              return _context3.a(2, response);
          }
        }, _callee3);
      }));
      function mutationFn(_x2) {
        return _mutationFn.apply(this, arguments);
      }
      return mutationFn;
    }(),
    onMutate: function onMutate(itemData) {
      var optimisticQuantity = itemData.isDigitalGiftCard || itemData.designViewId ? 1 : parseInt(itemData.quantity, 10) || 1;
      queryClient.setQueryData((0, _getQueryKey2["default"])(), function (currentCart) {
        var _currentCart$items, _currentCart$totals$q, _currentCart$totals;
        var isItemInCart = currentCart === null || currentCart === void 0 || (_currentCart$items = currentCart.items) === null || _currentCart$items === void 0 ? void 0 : _currentCart$items.find(function (item) {
          return item.skuId === itemData.skuId;
        });
        var currentTotalQuantity = (_currentCart$totals$q = currentCart === null || currentCart === void 0 || (_currentCart$totals = currentCart.totals) === null || _currentCart$totals === void 0 ? void 0 : _currentCart$totals.quantity) !== null && _currentCart$totals$q !== void 0 ? _currentCart$totals$q : 0;
        var updatedTotals = _objectSpread(_objectSpread({}, currentCart === null || currentCart === void 0 ? void 0 : currentCart.totals), {}, {
          quantity: currentTotalQuantity + optimisticQuantity
        });
        // If item is already in cart, optimistically increment quantity
        if (isItemInCart) {
          var _currentCart$items2;
          return _objectSpread(_objectSpread({}, currentCart), {}, {
            totals: updatedTotals,
            items: currentCart === null || currentCart === void 0 || (_currentCart$items2 = currentCart.items) === null || _currentCart$items2 === void 0 ? void 0 : _currentCart$items2.map(function (item) {
              return item.skuId === itemData.skuId ? _objectSpread(_objectSpread({}, item), {}, {
                quantity: item.quantity + optimisticQuantity
              }) : item;
            })
          });
        } else {
          // If item is not in cart, optimistically add it to the cart
          return _objectSpread(_objectSpread({}, currentCart), {}, {
            totals: updatedTotals,
            items: [_objectSpread(_objectSpread({}, itemData), {}, {
              quantity: optimisticQuantity
            })].concat(_toConsumableArray((currentCart === null || currentCart === void 0 ? void 0 : currentCart.items) || []))
          });
        }
      });
      return {
        itemData: itemData,
        optimisticQuantity: optimisticQuantity,
        meta: {
          dispatchCartUpdated: true,
          dispatchCartCountUpdated: true
        }
      };
    },
    onSuccess: function () {
      var _onSuccess = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4(data) {
        return _regenerator().w(function (_context4) {
          while (1) switch (_context4.n) {
            case 0:
              queryClient.setQueryData((0, _getQueryKey2["default"])(), data);
              _context4.n = 1;
              return queryClient.invalidateQueries({
                queryKey: (0, _getQueryKey3["default"])()
              });
            case 1:
              _context4.n = 2;
              return queryClient.invalidateQueries({
                queryKey: (0, _getQueryKey4["default"])()
              });
            case 2:
              _context4.n = 3;
              return queryClient.invalidateQueries({
                queryKey: (0, _getQueryKey5["default"])()
              });
            case 3:
              if (!(data !== null && data !== void 0 && data.warnings && data.warnings.length > 0)) {
                _context4.n = 4;
                break;
              }
              _context4.n = 4;
              return (0, _handleWarnings["default"])({
                warnings: data.warnings,
                data: data
              }, queryClient);
            case 4:
              return _context4.a(2);
          }
        }, _callee4);
      }));
      function onSuccess(_x4) {
        return _onSuccess.apply(this, arguments);
      }
      return onSuccess;
    }(),
    onSettled: function onSettled() {},
    onError: function () {
      var _onError = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee5(error, variables, context) {
        var _t2;
        return _regenerator().w(function (_context5) {
          while (1) switch (_context5.p = _context5.n) {
            case 0:
              queryClient.setQueryData((0, _getQueryKey2["default"])(), function (currentCart) {
                var _context$itemData$sku, _context$itemData, _context$optimisticQu, _currentCart$totals$q2, _currentCart$totals2, _currentCart$items3;
                var rollbackSkuId = (_context$itemData$sku = context === null || context === void 0 || (_context$itemData = context.itemData) === null || _context$itemData === void 0 ? void 0 : _context$itemData.skuId) !== null && _context$itemData$sku !== void 0 ? _context$itemData$sku : variables === null || variables === void 0 ? void 0 : variables.skuId;
                var rollbackQuantity = (_context$optimisticQu = context === null || context === void 0 ? void 0 : context.optimisticQuantity) !== null && _context$optimisticQu !== void 0 ? _context$optimisticQu : parseInt(variables === null || variables === void 0 ? void 0 : variables.quantity, 10) || 1;
                var currentTotalQuantity = (_currentCart$totals$q2 = currentCart === null || currentCart === void 0 || (_currentCart$totals2 = currentCart.totals) === null || _currentCart$totals2 === void 0 ? void 0 : _currentCart$totals2.quantity) !== null && _currentCart$totals$q2 !== void 0 ? _currentCart$totals$q2 : 0;
                var validItems = ((_currentCart$items3 = currentCart === null || currentCart === void 0 ? void 0 : currentCart.items) !== null && _currentCart$items3 !== void 0 ? _currentCart$items3 : []).map(function (item) {
                  return item.skuId !== rollbackSkuId ? item : _objectSpread(_objectSpread({}, item), {}, {
                    quantity: item.quantity - rollbackQuantity
                  });
                }).filter(function (item) {
                  return item.quantity > 0;
                }); // Covers use cases where a user somehow was able to add a non buyable product, like an OOS item

                return _objectSpread(_objectSpread({}, currentCart), {}, {
                  totals: _objectSpread(_objectSpread({}, currentCart === null || currentCart === void 0 ? void 0 : currentCart.totals), {}, {
                    quantity: Math.max(0, currentTotalQuantity - rollbackQuantity)
                  }),
                  items: validItems
                });
              });
              _context5.p = 1;
              _context5.n = 2;
              return (0, _handleErrors["default"])({
                error: error,
                params: variables
              }, queryClient);
            case 2:
              _context5.n = 4;
              break;
            case 3:
              _context5.p = 3;
              _t2 = _context5.v;
            case 4:
              return _context5.a(2);
          }
        }, _callee5, null, [[1, 3]]);
      }));
      function onError(_x5, _x6, _x7) {
        return _onError.apply(this, arguments);
      }
      return onError;
    }()
  };
};
var _default = exports["default"] = getAddItemOptions;